import { maxBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { STICKY_SECTION_CLASS } from 'src/components/molecules/StickySection/components/StickySection';

const { responsiveText, spacing } = theme;

export const ctaSectionWrapper = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      .${STICKY_SECTION_CLASS} & {
        margin: 0 0 ${spacing.lg}px;
      }
    `,
  )}
`;

export const purchasableCta = css`
  width: 100%;
`;

export const requiredFieldsMessage = css`
  ${responsiveText.BODY.SM};
  margin: ${spacing.xs}px 0 0;
  text-align: center;
  color: var(--neutral-black-70);
`;
